import React from "react";
import { Button, Input } from "semantic-ui-react";
import { WidgetProps } from "../types";
import Prompt from "../Prompt";
import Summary, { SummaryField, SummaryText, Actions } from "../Summary";

/** "Metaphor for your life" — one for today, one for tomorrow. */
const SECTIONS = [
  { key: "today", label: "My life today", placeholder: "My life is…" },
  { key: "tomorrow", label: "My life tomorrow", placeholder: "I want my life to be…" },
];

const MetaphorsForLife: React.FC<WidgetProps> = ({
  payload,
  update,
  submit,
  submitting,
  finished,
  question,
  currentUser,
}) => {
  const edit = (section: string, field: string) => (e) =>
    update({
      ...payload,
      [section]: { ...(payload[section] || {}), [field]: e.target.value },
    });

  const complete = SECTIONS.every(
    (s) => ((payload[s.key] || {}).name || "").trim().length > 0,
  );

  if (finished) {
    return (
      <Summary question={question} currentUser={currentUser}>
        {SECTIONS.map((s) => (
          <SummaryField key={s.key} label={s.label}>
            <div className="ix-value-lg">{(payload[s.key] || {}).name}</div>
            <SummaryText>{(payload[s.key] || {}).motivation}</SummaryText>
          </SummaryField>
        ))}
      </Summary>
    );
  }

  return (
    <div className="ui form assignment-form">
      <Prompt question={question} currentUser={currentUser} />

      {SECTIONS.map((s) => (
        <div key={s.key} className="ix-section">
          <div className="ix-label">{s.label}</div>
          <div className="field">
            <Input
              fluid
              placeholder={s.placeholder}
              value={(payload[s.key] || {}).name || ""}
              onChange={edit(s.key, "name")}
            />
          </div>
          <div className="field">
            <textarea
              rows={2}
              placeholder="Why does that fit?"
              value={(payload[s.key] || {}).motivation || ""}
              onChange={edit(s.key, "motivation")}
            />
          </div>
        </div>
      ))}

      <Actions>
        <Button
          primary
          circular
          className="challenge-submit"
          disabled={!complete || submitting}
          loading={submitting}
          onClick={submit}
        >
          Submit
        </Button>
      </Actions>
    </div>
  );
};

export default MetaphorsForLife;
